// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1oDG9","name":"ConsentHeader_name__2PxxP","birthday":"ConsentHeader_birthday__2pjhi","skeleton":"ConsentHeader_skeleton__qZ6b2"};